import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import * as Fields from 'support/fields'
import * as UI from 'ui'
import { Fieldset } from 'layouts'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'

export default function SalaryInformationFieldset ({ create = false }) {
  return (
    <Can permission={Permissions.EMPLOYMENTS_MANAGE_USERS_FULL}>
      <UI.CardWithHeader header={<Translation name='headers.salary_information' />}>

        <Fieldset cols={2}>

          <Fields.Input
            name='bank_reg'
            label={<Translation name='fields.bank_reg.label' />}
          />
          <Fields.Input
            name='bank_account'
            label={<Translation name='fields.bank_account.label' />}
          />

        </Fieldset>

      </UI.CardWithHeader>
    </Can>
  )
}
